import { FILE_MESSAGE_TYPES, MessageTypes } from '@/models/channels'

/**
 * Check if the QUESTION/ANSWER message is from v1 or v2 formatter.
 */
export const isQuestionnaireV2 = message => {
  return isAnswerMessageV2(message) || isQuestionMessageV2(message)
}

const isAnswerMessageV2 = message => {
  return message.type === MessageTypes.ANSWER && !!message.answer
}

const isQuestionMessageV2 = message => {
  return message.type === MessageTypes.QUESTION && !!message.question
}

export const getMessagesContext = isPrivate => {
  return isPrivate ? 'private' : 'public'
}

/**
 * Message components
 */

const messageTypesComponent = {
  [MessageTypes.TEXT]: 'CMessageText',
  [MessageTypes.QUESTION]: 'CMessageQuestion',
  [MessageTypes.ANSWER]: 'CMessageAnswer',
  [MessageTypes.AUDIO]: 'CMessageAudio',
  [MessageTypes.VIDEO]: 'CMessageVideo',
  [MessageTypes.IMAGE]: 'CMessageImage',
  [MessageTypes.DOCUMENT]: 'CMessageDocument',
  [MessageTypes.SPLIT_BAR]: 'CMessageSplitBar',
  [MessageTypes.ADD_PARTICIPANT]: 'CMessageParticipant',
  [MessageTypes.REMOVE_PARTICIPANT]: 'CMessageParticipant',
  [MessageTypes.VISUALIZATION]: 'CMessageVisualization',
  [MessageTypes.CHANNEL_ARCHIVED]: 'CMessageAction',
  [MessageTypes.CHANNEL_UNARCHIVED]: 'CMessageAction',
  [MessageTypes.CHANNEL_MERGED]: 'CMessageAction',
  [MessageTypes.CHANNEL_RENAMED]: 'CMessageAction',
  [MessageTypes.STARTED_QUESTIONNAIRE]: 'CMessageQuestionnaire',
  [MessageTypes.ENDED_QUESTIONNAIRE]: 'CMessageQuestionnaire',
  [MessageTypes.INTERNAL_REDIRECT]: 'CMessageInternalRedirect'
}

const messageContentTypes = [
  MessageTypes.TEXT,
  MessageTypes.ANSWER,
  MessageTypes.CHANNEL_ARCHIVED,
  MessageTypes.CHANNEL_MERGED,
  MessageTypes.CHANNEL_RENAMED,
  MessageTypes.CHANNEL_UNARCHIVED
]

const questionnaireTypes = [
  MessageTypes.STARTED_QUESTIONNAIRE,
  MessageTypes.ENDED_QUESTIONNAIRE
]

/**
 * Get message component and props based on message type
 * @param {Object} message - the message object
 * @param {String} fileLink - the link for media messages
 * @param {Object} channelMember - object with participant name and avatar
 * @param {Object} channelStaffs - Array of staffs
 * @returns Object with component (string) and props (object)
 */
export const getMessageComponent = (
  message,
  fileLink,
  channelMember,
  channelStaffs
) => {
  const messageComponent = {
    component: messageTypesComponent[message.type]
  }
  if (FILE_MESSAGE_TYPES.includes(message.type)) {
    return {
      ...messageComponent,
      props: {
        source: fileLink
      }
    }
  }

  if (messageContentTypes.includes(message.type)) {
    return {
      ...messageComponent,
      props: {
        content: message.content
      }
    }
  }

  if (message.type === MessageTypes.QUESTION) {
    return {
      ...messageComponent,
      props: {
        content: message.content,
        options: message.question?.input?.options
      }
    }
  }

  if (questionnaireTypes.includes(message.type)) {
    return {
      ...messageComponent,
      props: {
        start: message.type === MessageTypes.STARTED_QUESTIONNAIRE,
        content: message.content
      }
    }
  }

  if (message.type === MessageTypes.VISUALIZATION) {
    return {
      ...messageComponent,
      props: {
        content: message.content,
        channelMember: channelMember,
        channelStaffs: channelStaffs
      }
    }
  }

  //Return full message props
  return {
    ...messageComponent,
    props: { message }
  }
}
